import React from "react";
import { connect } from 'react-redux';
import BambooLeaveImport from "./bamboo-hr/BambooLeaveImport";
import WorkforceImport from "./workforce/WorkforceImport";

const IntegrationTimesheetImport = ({
    integrations,
    userPermissions,
}) => {
    if (userPermissions == 'Read') return null

    if (integrations?.includes('Tanda')) return <WorkforceImport isFor={'Leave'} />
    if (integrations?.includes('Bamboo HR')) return <BambooLeaveImport isFor={'Leave'} />

    return null;
}

const mapStateToProps = (state) => {
    const timeAttendanceList = Object.values(state.integration?.timeAttendance || {})?.reduce((prev, curr) => {
        prev.push(curr.name)
        return prev
    }, [])
    const hrisList = Object.values(state.integration?.hris || {})?.reduce((prev, curr) => {
        prev.push(curr.name)
        return prev
    }, [])
    return {
        deputyConnected: state.deputy.connected,
        deputyNeedsReconnection: state.deputy.needsReconnection,
        company: state?.company?.settings?.org,
        integrations: [...timeAttendanceList, ...hrisList],
        userPermissions: state?.permissions?.my?.permissions?.leave,
    }
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IntegrationTimesheetImport)

